const PlatformsData = [
    {
        img:"https://flexsub.shop/content/images/2022/06/1c5ce46e-266f-43f0-b543-75bf341239b5.png",
        Name:"LEETCODE",
        link:"https://leetcode.com/"
    },
    {
        img:"https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/062020/codeforces_logo.png?Qlx1_zCw.Q4T7PHPosbkLyNiBJQWX7GD&itok=6wPhjh1X",
        Name:"CODEFORCES",
        link:"https://codeforces.com/"
    },
    {
        img:"https://cdn.dribbble.com/users/70628/screenshots/1743345/media/584ad20c4711df6ab15612cc824d35d1.png?resize=400x300&vertical=center",
        Name:"CODE CHEF",
        link:"https://www.codechef.com/"
    },
    {
        img:"https://www.financialexpress.com/wp-content/uploads/2023/05/APIS-and-NxtWave-image-37-3.jpg",
        Name:"CODING NIJAS",
        link:"https://www.codingninjas.com/"
    },
    {
        img:"https://www.digitalfirstmagazine.com/wp-content/uploads/2020/05/interviewbit-550x330.jpg",
        Name:"INTERVIEW BIT",
        link:"https://www.interviewbit.com/"
    }
]

export default PlatformsData